import { useState } from 'react';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';
import PcModelModal from '../PcModelModal';
import styles from './styles';

const PcModelOverviewSpecs = ({ productType }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { pcModel, currentOptions, errors } = usePcConfigurator();

  const basePrice = Number(pcModel.price);

  // console.log(currentOptions);

  return (
    <>
      <button
        type="button"
        className="pc-model-overview-specs"
        onClick={() => setIsOpen(true)}
      >
        Show Current Config
      </button>

      <PcModelModal
        pcModel={pcModel}
        title="Current Specification"
        basePrice={basePrice}
        options={currentOptions}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        isButtonDisabled={errors.length > 0}
        productType={productType}
      />

      <style jsx>{styles}</style>
    </>
  );
};

export default PcModelOverviewSpecs;
